<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click="handleSaveSubmit">{{ $t('保存更改') }}</el-button>
      <el-button @click.native="$refs.treeTable.handleChangeExpandState()">{{expandState ? $t('收起') : $t('展开')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{ $t('批量删除') }}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('名称')">
        <el-input :placeholder="$t('名称')" v-model="searchForm.name" clearable />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="resetEmpty()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>
<!--    <template #tab-row>
      <div>
        <el-link :underline="false" type="primary" class="mb16" @click="handleAddRow(tableData)">+ 添加主分类</el-link>
      </div>
    </template>-->

    <template #table="{height}">
      <tree-table :column-list="columnList"
                  :data.sync="tableData"
                  :expand.sync="expandState"
                  :row-class-name="tableRowClassName"
                  :height="height" ref="treeTable"
                  :row-template="rowTemplate">

        <template #priority="{row}">
          <div>
            <el-input v-model="row.priority" v-if="row.isFirstRow" />
          </div>
        </template>

        <template #photo="{row}">
          <pic-upload
              v-model="row.photo"
              :action="$api.file.upload"
              :limit="1"
              :download-url="$api.file.downloadImg"
              width="80px"
              height="80px" />
        </template>

        <template #move="{row}">
          <topic-move
              :is-first="row.isFirstRow"
              :row="row"
              :list="tableData" />
        </template>

        <template #operate="{row}">
          <div class="fb-link-flex">
            <el-link type="primary" :underline="false" @click="handleCheck(row)">{{ $t('查看') }}</el-link>
            <el-link type="danger" :underline="false" @click="handleDelete(row)">{{ $t('删除') }}</el-link>
          </div>
        </template>
      </tree-table>
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import {handleBuildTreeData, handleDeleteTip, handleDeleteTreeNode} from "@/utils/levelUtils";
import PicUpload from "@/components/pic-upload/PicUpload.vue";
import AnkhList from "@/components/list/AnkhList.vue";
import TreeTable from "@/components/tree-table/TreeTable.vue";
import {resetEmpty} from "@/utils/common";
import TopicMove from "@/components/topic-move/TopicMove.vue";


export default {
  name: "TopicList",
  components: {TopicMove, TreeTable, AnkhList, PicUpload},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      // 新增row 需要的字段数据
      rowTemplate: {
        name: "",
        priority: "",
        expand: "yes",
        type: "admin",
        photo: "",
        createTimeStr: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
      },

      tableRef: null,
      expandState: true,

      columnList: [
        {label: "分类名称", prop: "name", type: "input", fixed: "left", minWidth: "400"},
        {label: "优先级", prop: "priority", minWidth: "200"},
        {label: "移动", prop: "move", type: "more", minWidth: "200"},
        {label: "图片", prop: "photo", type: "more", minWidth: "200"},
        {label: "默认展开", prop: "expand", type: "switch", minWidth: "100"},
        {label: "创建时间", prop: "createTimeStr", minWidth: "200"},
        {label: "操作", prop: "operate", minWidth: "100"},
      ],

    }
  },
  methods: {
    resetEmpty,
    // 查看
    handleCheck(row) {
      if(row.sub.length) {
        this.$router.push({
          path: "detail",
          query: {
            code: row.code,
          }
        })
      } else {
        this.$router.push({
          path: "/topic/dynamic",
          query: {
            code: row.code,
          }
        })
      }
    },

    // 提交
    async handleSaveSubmit() {
      try {
        const params = this.handleBuildParams(this.tableData);
        console.log("params", params);
        await request(this.$api.topicSort.save, params, {isJson: true});
        this.$message.success(this.$t('保存成功'));
        await this.handleSearch();
      }catch(e) {
         console.log(e);
      }
    },

    handleBuildParams(list) {
      return list.map((item, index) => {
        let sub = [];
        if(item.sub.length) {
          sub = this.handleBuildParams(item.sub);
        }
        return {
          name: item.name,
          priority: item.priority,
          photo: item.photo,
          content: item.content,
          code: item.isNewAdd ? null : item.code,
          sort: index + 1,
          expand: item.expand,
          type: item.type,
          sub
        }
      })
    },

    // 系统创建默认底色
    tableRowClassName({row}) {
      if(row.type === "admin") return "success-row";
      return null;
    },

    async handleDelete(row) {
      try {
        await handleDeleteTip();
        if (!row.isNewAdd) {
          await request(this.$api.topicSort.delete, {code: row.code});
        }
        this.tableData = handleDeleteTreeNode([row.code], this.tableData);
        this.$message.success(this.$t('操作成功'));
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      const selected = this.$refs.treeTable.handleGetSelected();
      if (!selected.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        await handleDeleteTip();
        let codes = selected.filter(f => !f.isNewAdd).map(item => item.code);
        if (codes.length) {
          await request(
              this.$api.topicSort.batchDelete,
              codes,
              {isJson: true},
          );
        }
        const delCodes = selected.map(item => item.code);
        this.$message.success(this.$t('操作成功'));
        this.tableData = handleDeleteTreeNode(delCodes, this.tableData);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch() {
      try {
        const params = {
          ...this.searchForm,
          onPage: false,
        }
        let res = await request(this.$api.topicSort.list, params);
        this.tableData = handleBuildTreeData(res.topicSorts, (item) => {
          return {
            createTimeStr: this.$moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
          }
        })
      } catch (e) {
        console.error(e);
      }
    },
  },
  mounted() {
    this.handleSearch();
  },
}
</script>

<style scoped>

/deep/ .cell {
  display: flex;
  align-items: center;
}

/deep/ .warning-row {
  background: oldlace;
}

/deep/ .success-row {
  background: #f0f9eb;
}

/deep/ .red {
  background: red;
}

</style>
